/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define([], function() {
    'use strict';

    function getBasePath() {
        var scripts = document.getElementsByTagName('script'),
            pattern = /(.*)tomtom.min.js/,
            i,
            path;
        for (i = 0; i < scripts.length; i++) {
            if (scripts[i].src) {
                path = pattern.exec(scripts[i].src);
                if (path) {
                    return path[1];
                }
            }
        }
        return '';
    }

    return {
        get: function(map) {
            var basePath = map && map.options && map.options.basePath ? map.options.basePath + '/' : getBasePath();
            return basePath + 'images';
        }
    };
});



// WEBPACK FOOTER //
// ./display/imagePath.js